import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { fetchCurrentIncidentStatus } from 'actions/profileActions';
import { fetchTeamTemplates } from 'actions/teamsActions';
import TemplateWizard from './TemplateWizard';
import { useFetchIncidentWorkspaceTeamStatus } from 'hooks/useFetchIncidentWorkspaceTeamStatus';

const IncidentTeamsFeatures = () => {
  const [showSelectTeamsTemplateDialog, setShowSelectTeamsTemplateDialog] =
    useState(false);

  const currentIncident = useSelector((state: any) => {
    return state.app.currentIncident;
  });
  const teamsTemplates = useSelector((state: any) => {
    return state.app.teamsTemplates;
  });
  const tenantId = useSelector((state: any) => {
    return state.app.tenantId;
  });

  const { data: teamsStatus, refetch: refetchTeamsStatus } =
    useFetchIncidentWorkspaceTeamStatus(currentIncident?.id ?? '');

  useEffect(() => {
    if (teamsStatus === 'inprogress') {
      const intervalId = setInterval(() => {
        refetchTeamsStatus();
      }, 5000);

      return () => clearInterval(intervalId);
    }
  }, [teamsStatus, refetchTeamsStatus]);

  const dispatch = useDispatch();

  const onClickGenerateTeamsSite = async () => {
    // This dispatch updates the field in state with the same value that the query returns
    // We are keeping this Redux update to preserve backwards compatibility
    await dispatch(fetchCurrentIncidentStatus());

    // But we reference the query data because this component does not rerender after the dispatch above
    if (teamsStatus === 'unstarted') {
      setShowSelectTeamsTemplateDialog(true);
      if (teamsTemplates.length == 0) {
        dispatch(fetchTeamTemplates(tenantId));
      }
    }
  };

  return (
    <>
      {Boolean(tenantId) && (
        <>
          {(!!currentIncident &&
            !currentIncident?.teams_id &&
            !currentIncident?.channel_id &&
            !currentIncident?.sharepoint_location &&
            teamsStatus === 'unstarted' && (
              <>
                <StylishNewButton
                  className="button--secondary w-md-auto ms-md-3 mt-md-0 ms-0 mt-2 w-100"
                  onClick={onClickGenerateTeamsSite}
                >
                  Generate Teams Site
                </StylishNewButton>
                {showSelectTeamsTemplateDialog && (
                  <TemplateWizard
                    tenantId={tenantId}
                    workspaceType="incident"
                    workspaceId={currentIncident.id}
                    setShowSelectTeamsTemplateDialog={
                      setShowSelectTeamsTemplateDialog
                    }
                  />
                )}
              </>
            )) ||
            (teamsStatus === 'inprogress' && (
              <div style={{ marginLeft: '16px' }}>
                Creating Teams Workspace...
              </div>
            )) ||
            (teamsStatus === 'done' && (
              <div style={{ marginLeft: '16px' }}>Teams Workspace Created!</div>
            ))}
        </>
      )}
    </>
  );
};
export default IncidentTeamsFeatures;
